import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  ModalFooter,
  Text,
  Select,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router';

export default function ModalReservaciones({
  isOpen,
  onClose,
  changeOtraCabana,
}) {

  const { t } = useTranslation();

  const navigate = useNavigate();

  const goReservar = () => {
    changeOtraCabana();
    onClose();
    navigate('/reservar');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={true}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('NO_FREE_NIGHTS')}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          {t('NO_AVAILABLE_NIGHTS_MESSAGE')}
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            onClick={onClose}
          >
              {t('CANCEL')}
          </Button>
          <Button
            colorScheme="blue"
            mr={3}
            onClick={goReservar}
          >
              {t('CONTINUE')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
